import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextAligning, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxMaxLine3FontLgBold extends ITextBoxProps {}

export const TextBoxMaxLine3FontLgBold = ({
  title,
  color = Colors.TEXT_ICON_PRIMARY,
  font = TextBoxTypes.FontLgBold,
  alignment = TextAligning.Left,
  maxLines = 3,
  ...rest
}: ITextBoxMaxLine3FontLgBold): JSX.Element => {
  return (
    <TextBox
      title={title}
      color={color}
      font={font}
      alignment={alignment}
      maxLines={maxLines}
      {...rest}
    />
  )
}
